import { Form, Input } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React, { FunctionComponent, useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmail, isEmpty } from 'ts-utils';
import { Color } from '../../config/Color';
import { ActionType } from '../../store/ActionTypes';
import { AppSelector, useAppDispatch, useAppStore } from '../../store/Store';
import { NextButton } from '../styles/LayoutButtons';

type Props = {
  showButton: boolean;
  setShowCheckout: (show: boolean) => void;
  /** Show a visible "Email address" label above the field. */
  labelled?: boolean;
};

export const EmailForm: FunctionComponent<Props> = (props) => {
  const user = useAppStore(AppSelector.userState);
  const dispatch = useAppDispatch();
  const initialEmail = user.email;
  const [email, setEmail] = useState(initialEmail ?? '');
  const [validEmail, setValidEmail] = useState(false);

  function handleSubmit() {
    if (isEmail(email)) {
      setValidEmail(true);
      // Not ideal but `name` should get updated later from the FinishAccountScreen
      dispatch({
        type: ActionType.TEMPORARY_REGISTER_USER,
        details: { email },
      });
    } else {
      alert('Please enter a valid email address.');
    }
  }

  // initialEmail becomes available asynchronously after the stripeIntent API call
  useEffect(
    function setEmailWhenInitialEmailBecomesAvailable() {
      if (isEmpty(email) && !isEmpty(initialEmail)) {
        setEmail(initialEmail);
      }
    },
    [initialEmail]
  );

  useEffect(
    function showCheckoutOnUserLogin() {
      if (user.userId !== undefined) {
        props.setShowCheckout(true);
      }
    },
    [user.userId]
  );

  useEffect(
    function resetValidEmailOnUserError() {
      if (user.error !== undefined) {
        setValidEmail(false);
      }
    },
    [user.error]
  );

  return (
    <Form onFinish={handleSubmit}>
      <FormItem>
        {props.labelled === true && <FieldLabel htmlFor="payment-email">Email address</FieldLabel>}
        <NiceInput
          id="payment-email"
          size="large"
          type="email"
          value={email}
          placeholder={props.labelled === true ? 'you@example.com' : 'Enter Email'}
          onChange={(e) => setEmail(e.target.value)}
          disabled={validEmail}
        />
      </FormItem>
      {props.showButton || (
        <FormItem>
          <NextButton hideArrow loading={user.loading}>
            Continue
          </NextButton>
        </FormItem>
      )}
    </Form>
  );
};

const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing._6px};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

const NiceInput = styled(Input)`
  border-radius: 10px;
  &[disabled] {
    border-color: ${Color.decorative.onAccent};
    color: #000;
    text-align: center;
  }
  &[disabled]:hover {
    border-color: ${Color.decorative.onAccent};
  }
`;
